module.exports = __webpack_public_path__ + "static/media/p_20_4.ea819f3c.png";